import clsx from "clsx";

import * as styles from "./Icon.css";
import { ElementType } from "react";
import Svg, { SvgProps } from "./Svg";

export type IconProps = {
  svg: ElementType;
  className?: string;
} & styles.IconVariants &
  SvgProps;

export default function Icon({ svg, className, ...props }: IconProps) {
  const { size='24px' } = props;
  return (
    <Svg
      svg={svg}
      className={clsx(styles.icon({ size: size }), className)}
      {...props}
    />
  );
}
